import React from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Icon,
  Flex,
  useColorModeValue
} from '@chakra-ui/react';
import { FaPlus, FaList, FaTicketAlt } from 'react-icons/fa';

/**
 * RaffleTabWrapper component - A reusable tabbed interface for raffle-related content
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.createRaffleContent - Content for the Create Raffle tab
 * @param {React.ReactNode} props.myRafflesContent - Content for the My Raffles tab
 * @param {React.ReactNode} props.activeRafflesContent - Content for the Active Raffles tab
 * @param {number} props.defaultIndex - Default selected tab index (0-based)
 * @param {function} props.onTabChange - Callback when tab changes
 */
const RaffleTabWrapper = ({ 
  createRaffleContent, 
  myRafflesContent, 
  activeRafflesContent,
  defaultIndex = 0,
  onTabChange
}) => {
  const tabBg = useColorModeValue('rgba(13, 16, 25, 0.7)', 'rgba(13, 16, 25, 0.7)');
  const selectedTabBg = useColorModeValue('rgba(128, 190, 255, 0.2)', 'rgba(128, 190, 255, 0.2)');
  const tabColor = useColorModeValue('gray.400', 'gray.400');
  const selectedTabColor = useColorModeValue('blue.300', 'blue.300');
  const borderColor = useColorModeValue('blue.400', 'blue.400');

  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <Box w="100%">
      <Tabs 
        variant="enclosed" 
        defaultIndex={defaultIndex} 
        onChange={handleTabChange}
        colorScheme="blue"
      >
        <TabList mb={4}>
          <Tab 
            _selected={{ 
              color: selectedTabColor, 
              bg: selectedTabBg,
              borderColor: borderColor,
              borderBottomColor: selectedTabBg
            }}
            color={tabColor}
            bg={tabBg}
            borderTopRadius="md"
            mr={1}
          >
            <Flex align="center">
              <Icon as={FaPlus} mr={2} />
              Create Raffle
            </Flex>
          </Tab>
          <Tab 
            _selected={{ 
              color: selectedTabColor, 
              bg: selectedTabBg,
              borderColor: borderColor,
              borderBottomColor: selectedTabBg
            }}
            color={tabColor}
            bg={tabBg}
            borderTopRadius="md"
            mr={1}
          >
            <Flex align="center">
              <Icon as={FaList} mr={2} />
              My Raffles
            </Flex>
          </Tab>
          <Tab 
            _selected={{ 
              color: selectedTabColor, 
              bg: selectedTabBg,
              borderColor: borderColor,
              borderBottomColor: selectedTabBg
            }}
            color={tabColor}
            bg={tabBg}
            borderTopRadius="md"
          >
            <Flex align="center">
              <Icon as={FaTicketAlt} mr={2} />
              Active Raffles
            </Flex>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel p={0}>
            {createRaffleContent}
          </TabPanel>
          <TabPanel p={0}>
            {myRafflesContent}
          </TabPanel>
          <TabPanel p={0}>
            {activeRafflesContent}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default RaffleTabWrapper;
